import { ReactNode } from 'react';
import { FormatOptionLabelMeta } from 'react-select';

import TextHighlighter from 'components/text/TextHighlighter';

type Option = {
  label: ReactNode;
  value: string;
};

export function formatOptionLabelWithHighlight<T extends Option = Option>(
  { label }: T,
  { inputValue }: FormatOptionLabelMeta<T>,
): ReactNode {
  if (typeof label !== 'string') {
    return label;
  }

  return <TextHighlighter text={label} textToHighlight={inputValue} />;
}
